import { cn } from '@gik/core/utils/classnames';

type GroupHeaderClassMapOptions = {
  muted?: boolean;
  hasGradient?: boolean;
};

export default {
  groupHeroRoot: () => 'pt-8',
  groupHeroShareRow: () => 'flex w-full items-end justify-end pr-4 md:pr-0',
  groupHeroShareButtonWrap: () => '',
  groupHeroCard: () =>
    cn(
      // layout
      'flex items-center justify-center gap-2 max-w-[685px] mx-auto',
      // font
      'text-neutral-800',
      // surface
      'rounded-md bg-neutral-100',
      // spacing
      'mt-4 p-4',
      // typography
      'text-center'
    ),
  groupHeroTitle: () => 'text-center text-2xl font-bold block',
  groupHeroDescription: () =>
    cn(
      // spacing
      'm-0',
      // typography
      'text-center'
    ),
  groupHeroDescriptionWrapper: () => '',
  groupHeaderRoot: () => 'gik-inkind-group-header flex h-full shrink-0 items-center justify-center',
  groupHeaderKeepProp: () => 'min-h-40 [&>*]:min-h-40',
  // No top margin — the hero banner must sit flush under the top nav
  // (GIK-11047 #10). Height comes from the aspect ratio (~257px at desktop width).
  groupHeaderWrapper: () => 'relative h-full w-full',
  groupHeaderActions: ({ muted }: GroupHeaderClassMapOptions = {}) =>
    cn(
      // layout
      'flex max-w-[calc(100%-0.5rem)] flex-wrap justify-end gap-2',
      // position
      'absolute top-3 z-20',
      // interaction
      muted && 'pointer-events-none opacity-30'
    ),
  groupHeaderSection: ({ hasGradient }: GroupHeaderClassMapOptions = {}) =>
    cn(
      // layout
      'flex h-full w-full items-center justify-center',
      // surface
      'overflow-hidden rounded-b-2xl',
      hasGradient &&
        // fallback gradient when background image is not used
        'bg-gradient-to-bl from-[var(--gradient-color-1)] to-[var(--gradient-color-2)]'
    ),
  groupHeaderLogo: () => 'z-10 block',
  groupHeaderLogoFallback: () =>
    cn(
      // stacking + display — smaller on mobile so it clears the Group Settings pill
      'z-10 flex h-[54px] w-[150px] sm:h-[83px] sm:w-[237px] items-center justify-center whitespace-nowrap uppercase font-heading cursor-pointer',
      // surface
      'rounded-md border border-dashed border-2 border-white/50 backdrop-blur-sm',
      // spacing
      'px-4 sm:px-6',
      // typography
      'text-center text-sm sm:text-md font-semibold text-white'
    ),
};
